// import services from '@/services/index';
import remarkParse from 'remark-parse';
import remarkGfm from 'remark-gfm';
import remarkRehype from 'remark-rehype';
import rehypeParse from 'rehype-parse';
import rehypeRaw from 'rehype-raw';
import rehypeStringify from 'rehype-stringify';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import { unified } from 'unified';

export default function helpersFactory(services) {
  const schema = {
    ...defaultSchema,
    tagNames: [...defaultSchema.tagNames, 'img', 'sup'],
    attributes: {
      ...defaultSchema.attributes,
      img: ['src', 'alt', 'title', 'width', 'height'],
    },
    protocols: {
      ...defaultSchema.protocols,
      src: ['http', 'https', 'mailto', '/'],
    },
  };

  return {
    init,
    set,
    get,
    copyObject,
    hasValue,
    isEmpty,
    sanitizeHTML,
    sanitizeMarkdown,
  };

  ////////////////////
  function init() {
  }

  function set(obj, path, value) {
    if (!path) {
      return obj;
    }

    let split = path.split('.');
    if (split.length > 1) {
      obj[split[0]] = obj[split[0]] ? obj[split[0]] : {};
      let p1 = split.shift();
      set(obj[p1], split.join('.'), value);
    }
    else {
      obj[split[0]] = value;
    }
  }

  function get(obj, path, value) {
    if (!path) {
      return value;
    }

    let split = path.split('.');
    let myObj = obj;
    for (let i = 0; i < split.length; i++) {
      myObj = myObj[split[i]];
      if (!myObj) {
        break;
      }
    }

    return myObj ? myObj : value;
  }

  function copyObject(object) {
    return object ? JSON.parse(JSON.stringify(object)) : null;
  }

  function hasValue(item) {
    return item === undefined || item === null;
  }

  function isEmpty(item) {
    return item === undefined || item === null || item.trim() === '';
  }

  function sanitizeHTML(html) {
    if (!html) {
      return '';
    }

    return unified()
      .use(rehypeParse, { fragment: true })
      // .use(rehypeSanitize, schema)
      .use(rehypeStringify)
      .processSync(html)
      .toString();
  }

  function sanitizeMarkdown(markdown) {
    if (!markdown) {
      return '';
    }

    return unified()
      .use(remarkParse)
      .use(remarkGfm)
      .use(remarkRehype, { allowDangerousHtml: true })
      .use(rehypeRaw)
      .use(rehypeSanitize, schema)
      .use(rehypeStringify)
      .processSync(markdown)
      .toString();
  }
}
